import styled from "styled-components";
import { SliderPartHighlighter } from "@template/components/Slider/SliderPart/styles.ts";
import { ColorKey } from "@template/theme";

export const SliderWrapper = styled.div<{
  $color: ColorKey;
  $isUser?: boolean;
  $altStyling?: boolean;
}>`
  width: 100%;
  max-width: 100%;
  height: 100%;
  display: flex;
  gap: 4px;
  align-items: center;

  ${SliderPartHighlighter} {
    background: ${({ theme, $color, $isUser, $altStyling }) =>
      $isUser && $altStyling
        ? theme.colors[$color].default
        : $isUser && !$altStyling
          ? theme.colors[$color].default[0]
          : theme.colors[$color].default};
  }

  ${({ theme }) => theme.breakpoints.md.query} {
    gap: 2px;
  }

  ${({ theme }) => theme.breakpoints.sm.query} {
    display: none;
  }
`;

export const SliderContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 12px;
  min-width: max-content;
  width: 100%;
`;

// export const SliderPartsContainer = styled.div<{
//   $max: number;
// }>`
//   width: 100%;
//   gap: 4px;
//   display: grid;
//   grid-template-columns: repeat(${({ $max }) => $max}, 1fr);

//   ${({ theme }) => theme.breakpoints.md.query} {
//     gap: 2px;
//   }

//   ${({ theme }) => theme.breakpoints.sm.query} {
//     gap: 1px;
//   }
// `;

export const SliderPartsContainer = styled.div<{
  $max: number;
  $current: number;
}>`
  width: 100%;
  gap: 4px;
  display: grid;
  grid-template-columns: repeat(${({ $max }) => $max}, 1fr);
  position: relative;

  &::after {
    content: "+";
    position: absolute;
    right: -15px; // You can tweak this for better alignment
    top: 30%;
    transform: translateY(-53%);
    color: ${({ theme, $current }) =>
      $current >= 50
        ? theme.colors["primary"].default
        : theme.colors.default[400]};
    font-size: 16px;
    font-weight: 500;
    pointer-events: none;
    user-select: none;
  }

  ${({ theme }) => theme.breakpoints.md.query} {
    gap: 2px;
  }

  ${({ theme }) => theme.breakpoints.sm.query} {
    gap: 1px;
  }
`;

export const RangeInput = styled.input`
  position: absolute;
  top: 0;
  left: -2px;
  transform: translateY(-50%);
  width: calc(100% + 2px);
  -webkit-appearance: none;
  appearance: none;
  outline: none;
  background: none;
  opacity: 0;

  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    width: 14px;
    height: 14px;
    border-radius: 50%;
    cursor: pointer;
    background: transparent;
  }
`;

export const SliderLabelsWrapper = styled.div`
  position: relative;
  height: 16px;
`;

export const StartWrapper = styled.div`
  display: flex;
  height: 100%;
  width: 24px;
  flex-direction: column;
  gap: 12px;
  cursor: pointer;
  max-height: 32px;
`;

export const StartLabelWrapper = styled.div`
  position: relative;
  height: 16px;
`;

export const SliderThumb = styled.div<{ $altStyling?: boolean }>`
  width: 16px;
  height: 16px;
  border-radius: 50%;
  cursor: pointer;
  background: ${({ theme, $altStyling }) =>
    $altStyling ? theme.colors.primary[50] : theme.colors.default[900]};
  top: 3px;
  position: absolute;
  transform: translateY(-55%);
  pointer-events: none;
`;

export const ValueContainer = styled.div`
  position: relative;
  width: 100%;
  min-width: max-content;
  bottom: calc(100% + 20px);
  left: 50%;
  transform: translateX(-50%);
`;
